// 如果本地不做此配置，BASE_URL为lucky-cli注入，如果非lucky-cli构建的需要自己处理本地和生产的publicPath
__webpack_public_path__ = window.__publicPath || process.env.BASE_URL